// ** Custom Components
import { StyledText } from "./Text.styled";
import { StyledIcon } from "./Icon.styled";

// #####################################################

export const StyledArrow = () => (
	<StyledText>
		<StyledIcon />
	</StyledText>
);

// #####################################################
